import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoWalletOutline } from "react-icons/io5";
import { getWallet } from "../api/staff.api";
import { getStaffId } from "../utils/storage";
import LoadingState from "./States/LoadingState";

const WalletWidget = () => {
  const [walletData, setWalletData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const staffId = getStaffId();

  useEffect(() => {
    if (!staffId) {
      setLoading(false);
      return;
    }
    getWallet(staffId)
      .then((response) => setWalletData(response.data))
      .catch((err) => console.error("Wallet widget error:", err))
      .finally(() => setLoading(false));
  }, [staffId]);

  if (loading) {
    return (
      <div className="card p-4">
        <LoadingState branded brandedCompact message="Loading wallet…" className="py-4" />
      </div>
    );
  }

  if (!walletData) return null;

  const balance = walletData.wallet_balance || 0;
  const debits = (walletData.transaction_history || [])
    .filter((t) => t.type === "debit")
    .reduce((sum, t) => sum + (t.totalAmount || 0), 0);
  const total = debits + balance;
  const usedPct = total > 0 ? Math.min(100, (debits / total) * 100) : 0;

  return (
    <div className="card p-4 relative overflow-hidden">
      <div
        className="absolute top-0 right-0 w-32 h-32 rounded-full bg-primary-fixed/10 -translate-y-1/2 translate-x-1/4 pointer-events-none"
        aria-hidden
      />

      <div className="flex items-center justify-between mb-2 relative">
        <h3 className="font-semibold text-on-primary-fixed-var">Corporate Wallet</h3>
        <IoWalletOutline className="text-primary" size={20} />
      </div>

      <p className="text-xs text-on-surface-variant mb-1 relative">Available Balance</p>
      <p className="text-3xl font-bold text-primary mb-4 relative">₹{balance.toLocaleString()}</p>

      {total > 0 && (
        <>
          <div className="flex justify-between text-xs text-on-surface-variant mb-2 relative">
            <span>₹{debits.toLocaleString()} Used</span>
            <span>₹{total.toLocaleString()} Total</span>
          </div>
          <div className="h-2 bg-surface-container rounded-full overflow-hidden mb-4 relative">
            <div
              className="h-full bg-primary-container rounded-full transition-all"
              style={{ width: `${usedPct}%` }}
            />
          </div>
        </>
      )}

      <button
        onClick={() => navigate("/wallet")}
        className="btn-outline w-full flex items-center justify-center gap-1 text-sm relative"
      >
        View Transactions →
      </button>
    </div>
  );
};

export default WalletWidget;
